import { TeamId, PlayerId, ChecklistItemId, ChecklistItemStatus } from "@ollie-sports/models";
import { getUniversalHelpers } from "../../helpers";

export async function checklistItem__client__updateChecklistItemNotes(p: { checklistItemId: ChecklistItemId; notes: string }) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  await h.ChecklistItem.update({ id: p.checklistItemId, doc: { notes: p.notes } });
}

// i18n certified - complete
